<div class="list d-flex flex-column w-100">
  <div *ngFor="let record of metaDataList; let first = first" [class.first]="first" class="record py-3 d-flex">
    <div class="key" [attr.data-testid]="'about' + record[0].replace('Detail_Page_About_', '')">{{ record[0] | translate }}:</div>
    <div class="values">
      <ng-container *ngFor="let value of record[1]; let last = last">
        <a
          *ngIf="value.route; else notLink"
          [routerLink]="value.route"
          class="value"
          [class.not-link]="!value.route"
          (click)="onContentClick(value.engName || value.localizedText)"
          >{{ value.localizedText }}</a
        >
        <ng-template #notLink>
          <span class="value">{{ value.localizedText }}</span> </ng-template
        >{{ last ? '' : ', ' }}
      </ng-container>
    </div>
  </div>
</div>
